
<div class="form__group--border pt-32 pb-8">
  <h2 class="pb-24 heading-2">Share your job preferences</h2>
  <legend class="form__label pb-4">Maximum distance you'll travel for a job</legend>
  <poppins-dropdown
    id="distance-willing-to-travel"
    ref="maxDistance"
    v-model="distanceWillingToTravel"
    labelName="# of miles"
    class="mb-24"
    :options="options"
    :status="formStatuses.distanceWillingToTravel"
    :helperText="helperText(formStatuses.distanceWillingToTravel)"
    @blur="validate"
  />
</div>
